/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {PaginatedList} from "../../models/paginator/paginated-list";
import {SurveyRespondentModel} from "../../models/survey-respondent-model";

export interface SurveyRespondentsGetParams {
    accountGuid: string;
    pageNumber?: number;
    pageSize?: number;
    searchFilter?: string;
    sortKey?: string;
    sortDirection?: string;
}

export function surveyRespondentsGet(
    http: HttpClient, rootUrl: string, params: SurveyRespondentsGetParams, headers: HttpHeaders, context?: HttpContext
): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentModel>>> {

    const rb = new RequestBuilder(rootUrl, surveyRespondentsGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.query('accountGuid', params.accountGuid)
    if (params.pageNumber) {
        rb.query('pageNumber', params.pageNumber)
    }
    if (params.pageSize) {
        rb.query('pageSize', params.pageSize)
    }
    if (params.searchFilter) {
        rb.query('searchFilter', params.searchFilter)
    }
    if (params.sortKey) {
        rb.query('sortKey', params.sortKey)
    }
    if (params.sortDirection) {
        rb.query('sortDirection', params.sortDirection)
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<PaginatedList<SurveyRespondentModel>>;
        })
    );
}

surveyRespondentsGet.PATH = '/api/v1/survey-respondents';
